export default __webpack_public_path__ + "72f01fe40739c2c9db17232bfb419b46.webp";